export function sortMap(a: string, b: string) {
  return a.localeCompare(b);
}
